@if (favorites$ | async; as favorites) {
  <div
    class="bg-surface flex flex-col grow border rounded-md w-full mt-1 overflow-hidden"
  >
    @for (favorite of favorites; track trackByFn($index, favorite)) {
      <li
        [ngClass]="{ 'border-b border-b-solid border-b-separator': true }"
        class="w-full flex justify-between nowrap items-center cursor-pointer"
      >
        <div class="flex w-full" (click)="selectArtikel.emit(favorite.item)">
          <div class="w-20 sm:w-24 shrink-0">
            @if (favorite.item.thumbnail) {
              <img
                alt="{{ favorite.item.title1 }}"
                [src]="favorite.item.thumbnail | media"
                class="w-full h-full object-cover aspect-square"
              />
            } @else {
              <div
                class="w-full h-full bg-surface flex items-center justify-center aspect-square"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-6 h-6 text-color opacity-40"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.587-1.587a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
              </div>
            }
          </div>

          <div
            class="flex flex-col justify-between min-w-0 border-l border-separator p-2"
          >
            <h6 class="font-normal text-sm text-light">{{ favorite.item.number }}</h6>
            <h6 class="font-semibold text-sm">{{ favorite.item.title1 }}</h6>
            <h6 class="font-normal text-sm">
              {{ favorite.item.title2 || favorite.item.title3 }}
            </h6>
            @if (favorite.item.title4 | isDefinedNotEmpty) {
              <span class="text-sm text-light">{{ favorite?.item?.title4 }}</span>
            }
          </div>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6 opacity-20 scale-90"
          (click)="selectArtikel.emit(favorite.item)"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M8.25 4.5l7.5 7.5-7.5 7.5"
          />
        </svg>
      </li>
    }
  </div>
}
